import MainPanel from "../../components/MainPanel/MainPanel";
import DatePicker from "../../components/Misc/DatePicker";
import { useCustomSnackbar } from "../../components/Misc/useSnackbar";
import CustomSelect from "../../components/UIElements/CustomSelect";
import Input from "../../components/UIElements/Input";
import Select from "../../components/UIElements/Select";
import DefaultLayout from "../../layout/Layout";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { createAccount, getSites } from "../../service";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/actions";
import MultiSelect from "../../components/UIElements/Multiselect";

const AddAccount = () => {
  const booleanOpt = [
    { name: "Yes", value: true },
    { name: "No", value: false },
  ];
  const [sites, setSites] = useState([]);
  const [formData, setData] = useState({
    active: true,
    auto_po: true,
    auto_po_from: "",
    axs_authorized: true,
    disable_sapi: false,
    disable_yapi_transfers: false,
    disable_zero_amount_auto_po: false,
    do_not_barcode: false,
    exclude_default_notes: false,
    password: "",
    proxy_url: "",
    proxy_url_enabled: false,
    reset_password_enabled: false,
    site_id: "",
    username: "",
    internal_notes: "",
    custom_notes: "",
    vendor_id: "",
    internal_tags: [],
  });
  const { user } = useSelector((state) => state.user);
  const { tags } = useSelector((state) => state.account);
  const showToast = useCustomSnackbar();
  const toast = useCustomSnackbar();
  useEffect(() => {
    getSiteData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const dispatch = useDispatch();
  const getSiteData = async () => {
    dispatch(setLoading({ stat: true, text: "Getting Site Data" }));
    const { status, data: sites } = await getSites();
    dispatch(setLoading(false));
    if (status) {
      const uniqueOptionsMap = new Map();
      for (const option of sites) {
        const { description } = option;
        if (!uniqueOptionsMap.has(description)) {
          uniqueOptionsMap.set(description, option);
        }
      }
      const uniqueOptions = Array.from(uniqueOptionsMap.values());
      setSites(uniqueOptions);
    } else {
      setSites([]);
      toast({
        type: "warning",
        message: "Can not get the sites data.",
      });
    }
  };

  const handleChanage = (e) => {
    let { name, value } = e.target;
    if (value === "true") value = true;
    if (value === "false") value = false;
    setData((prev) => ({ ...prev, [name]: value }));
    if (name === "username") {
      setData((prev) => ({ ...prev, internal_notes: value }));
    }
  };

  const renderOption = (props, option) => {
    const { active, description, league, thumbnails } = option;
    delete props.key;
    return (
      <div className="bg-gray flex items-center" key={props.id} {...props}>
        {thumbnails ? (
          <img width={20} src={thumbnails["48x48"]} alt="thumb" />
        ) : (
          <Icon icon="material-symbols:globe" className="text-xl" />
        )}
        <p className="ml-2">
          {description}
          <span className="ml-3 text-sm text-warning">{league}</span>
        </p>
        <p
          className={`ml-auto text-sm text-${active === true ? "primary" : "danger"
            }`}
        >
          {active === true ? "Active" : "Inactive"}
        </p>
      </div>
    );
  };
  const getOptionLabel = (option) => {
    return option.description;
  };

  const addAccount = async () => {
    const {
      auto_po,
      auto_po_from,
      password,
      username,
      vendor_id,
      site_id,
      proxy_url,
      proxy_url_enabled,
    } = formData;
    if (
      (auto_po && auto_po_from === "") ||
      !password ||
      !username ||
      !vendor_id ||
      !site_id ||
      (proxy_url_enabled && !proxy_url)
    ) {
      showToast({
        type: "warning",
        message: "Please complete the form.",
      });
      return;
    }
    dispatch(setLoading({ stat: true, text: "Adding Acccount" }));
    const response = await createAccount(formData);
    const { status, account } = response;
    dispatch(setLoading(false));
    if (status && account) {
      showToast({
        type: "success",
        message: "Account has been created successfully.",
      });
    } else {
      showToast({
        type: "error",
        message: "Something went wrong. Please try again later.",
      });
    }
  };
  return (
    <DefaultLayout isLogin={false}>
      <MainPanel>
        <div className="flex items-center">
          <p className="font-semibold">Add account</p>
          <Link
            to="/account/list"
            className="inline-flex items-center justify-center rounded-md border ml-auto py-1 px-4 text-white text-center font-medium hover:bg-opacity-90 lg:px-8 xl:px-10"
          >
            Go back
          </Link>
        </div>
        <div className="md:px-17.5 w-full rounded-lg bg-white px-8 py-12 dark:bg-boxdark md:py-15">
          <div className="mb-4.5 flex flex-col gap-6 xl:flex-row items-end">
            <CustomSelect
              options={sites}
              renderOption={renderOption}
              getOptionLabel={getOptionLabel}
              onChange={handleChanage}
              label="Select a Site"
              name="site_id"
            />
            {/* <Input
              label="Vendor ID"
              name="vendor_id"
              placeholder="Vendor ID"
              value={formData.vendor_id}
              onChange={handleChanage}
            /> */}
          </div>
          <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
            <Input
              label="Username"
              name="username"
              value={formData.username}
              onChange={handleChanage}
            />
            <Input
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChanage}
            />
            <Select
              value={formData.reset_password_enabled}
              name="reset_password_enabled"
              options={booleanOpt}
              label="Enable Reset Password"
              onChange={handleChanage}
              disabled
            />
          </div>
          <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
            <Input
              label="Internal Notes"
              name="internal_notes"
              value={formData.internal_notes}
              onChange={handleChanage}
            />
            <MultiSelect
              label="Internal Tags"
              name="internal_tags"
              value={formData.internal_tags}
              options={user.role === "admin" ? tags || [] : user?.tags || []}
              onChange={handleChanage}
            />
            <Input
              label={<label>Custom Notes <span className="ml-2">( <i className="font-bold text-primary">noseats NOTNOW wallet</i> for fire accounts )</span></label>}
              name="custom_notes"
              value={formData.custom_notes}
              onChange={handleChanage}
            />
          </div>
          {/* <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
           <Select
              label="Custom Inventory Tag"
              name="po_inventory_tags"
              value={formData.po_inventory_tags}
              onChange={handleChanage}
              options={(user.role == "admin"
                ? tags || []
                : user?.tags || []
              ).map((x) => ({
                name: x,
                value: x,
              }))}
            /> 
          </div>*/}
          <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
            <Select
              value={formData.auto_po}
              name="auto_po"
              options={[
                { name: "Yes", value: true },
                { name: "No", value: false },
              ]}
              label="Auto PO"
              onChange={handleChanage}
            />
            <div className="w-full">
              <DatePicker
                label="Auto PO from"
                value={formData.auto_po_from}
                onChange={handleChanage}
                name="auto_po_from"
              />
            </div>
          </div>
          <div className="border-2 border-dashed border-bodydark2 p-5 rounded-lg mb-5 mt-8">
            <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
              <Select
                value={formData.axs_authorized}
                name="axs_authorized"
                options={booleanOpt}
                label="AXS Authorized"
                onChange={handleChanage}
                disabled
              />
              <Select
                value={formData.disable_zero_amount_auto_po}
                name="disable_zero_amount_auto_po"
                options={booleanOpt}
                label="Disable Zero Amount Auto PO"
                onChange={handleChanage}
                disabled
              />
              <Select
                value={formData.disable_yapi_transfers}
                name="disable_yapi_transfers"
                options={booleanOpt}
                label="Disable YAPI Transfers"
                onChange={handleChanage}
                disabled
              />
            </div>
            <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
              <Select
                value={formData.disable_sapi}
                name="disable_sapi"
                options={booleanOpt}
                label="Disable SAPI"
                onChange={handleChanage}
                disabled
              />
              <Select
                value={formData.do_not_barcode}
                name="do_not_barcode"
                options={booleanOpt}
                label="Do not Barcode"
                onChange={handleChanage}
                disabled
              />
              <Select
                value={formData.exclude_default_notes}
                name="exclude_default_notes"
                options={booleanOpt}
                label="Exclude Default Notes"
                onChange={handleChanage}
                disabled
              />
              {/* <div className="mb-4.5 flex flex-col gap-6 xl:flex-row items-end">
            <div className="xl:w-1/2">
              <Select
                value={formData.proxy_url_enabled}
                name="proxy_url_enabled"
                options={booleanOpt}
                label="Use Proxy"
                onChange={handleChanage}
              />
            </div>
            <Input
              label="Proxy URL"
              name="proxy_url"
              placeholder="https://www.proxy.com"
              value={formData.proxy_url}
              onChange={handleChanage}
              disabled={!formData.proxy_url_enabled}
            />
          </div> */}
            </div>
          </div>
          <div className="-mx-3 flex flex-wrap gap-y-4">
            <div className="2xsm:w-1/2 w-full px-3"></div>
            <div className="2xsm:w-1/2 w-full px-3">
              <button
                onClick={addAccount}
                className="block w-full rounded border border-primary bg-primary p-3 text-center font-medium text-white transition hover:bg-opacity-90"
              >
                Add Account
              </button>
            </div>
          </div>
        </div>
      </MainPanel>
    </DefaultLayout>
  );
};

export default AddAccount;
